
// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


// Afidium
import { DateFieldSetComponent } from './date-field-set.component';
import { PopupMenuModule } from 'libraries/component/popup-menu/popup-menu.module';
import { DateRangeModule } from 'libraries/module/formbuilder/fields/date-range/date-range.module';
import { ButtonModule } from 'libraries/module/formbuilder/fields/button/button.module';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        PopupMenuModule,
        DateRangeModule,
        ButtonModule,
        FontAwesomeModule,
    ],
    declarations: [
        DateFieldSetComponent,
    ],
    exports: [
        DateFieldSetComponent,
    ],
    providers: [],
})
export class DateFieldSetModule { }
